"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useVisualProps = useVisualProps;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _constants = require("./constants");
function useVisualProps(props) {
  const theme = (0, _mui.useTheme)();
  const {
    elevation = 2,
    expandOnFocus = false,
    height,
    IconButtonProps = {},
    size = 'medium',
    variant = 'contained',
    width
  } = props;
  const pickerHeight = (0, _react.useMemo)(() => {
    if (typeof height === 'number' && height >= _constants.TEXT_MEDIUM_HEIGHT) {
      if (variant === 'text' && size === 'medium' && height > _constants.TEXT_MEDIUM_HEIGHT) {
        return `${height}rem`;
      }
      if (variant === 'text' && size === 'large' && height > _constants.TEXT_LARGE_HEIGHT) {
        return `${height}rem`;
      }
      if (variant === 'contained' && size === 'medium' && height > _constants.CONTAINED_MEDIUM_HEIGHT) {
        return `${height}rem`;
      }
      if (variant === 'contained' && size === 'large' && height > _constants.CONTAINED_LARGE_HEIGHT) {
        return `${height}rem`;
      }
    }
    return undefined;
  }, [height, size, variant]);
  const cssProps = (0, _react.useMemo)(() => {
    const shadowLevel = elevation >= 0 && elevation <= 24 ? Math.floor(elevation) : 2;
    const pickerWidth = typeof width === 'undefined' ? '100%' : typeof width === 'number' ? `${width}px` : width;
    const contained = variant === 'contained';
    const pickerCssProps = {
      holder: {
        gridTemplateColumns: contained ? `${_constants.CONTAINED_MEDIUM_BUTTON_SIZE} ${_constants.MEDIUM_INPUT_WIDTH} ${_constants.CONTAINED_MEDIUM_BUTTON_SIZE}` : `${_constants.TEXT_MEDIUM_BUTTON_SIZE} ${_constants.MEDIUM_INPUT_WIDTH} ${_constants.TEXT_MEDIUM_BUTTON_SIZE}`,
        height: contained ? `${_constants.CONTAINED_MEDIUM_HEIGHT}rem` : `${_constants.TEXT_MEDIUM_HEIGHT}rem`,
        minWidth: _constants.MEDIUM_MIN_WIDTH,
        width: pickerWidth,
        padding: contained ? _constants.CONTAINED_PADDING : _constants.TEXT_PADDING,
        borderRadius: contained ? 100 : 0,
        background: contained ? theme.palette.common.white : 'transparent',
        boxShadow: contained ? theme.shadows[shadowLevel] ?? 'none' : 'none'
      },
      button: {
        fontSize: contained ? _constants.CONTAINED_MEDIUM_FONT_SIZE : _constants.TEXT_MEDIUM_FONT_SIZE,
        width: contained ? _constants.CONTAINED_MEDIUM_BUTTON_SIZE : _constants.TEXT_MEDIUM_BUTTON_SIZE,
        height: contained ? _constants.CONTAINED_MEDIUM_BUTTON_SIZE : _constants.TEXT_MEDIUM_BUTTON_SIZE
      },
      input: {
        minWidth: _constants.MEDIUM_INPUT_WIDTH,
        width: _constants.MEDIUM_INPUT_WIDTH,
        height: contained ? _constants.CONTAINED_MEDIUM_BUTTON_SIZE : _constants.TEXT_MEDIUM_BUTTON_SIZE
      }
    };
    if (size === 'large') {
      pickerCssProps.holder.gridTemplateColumns = `${_constants.LARGE_BUTTON_SIZE} ${_constants.LARGE_INPUT_WIDTH} ${_constants.LARGE_BUTTON_SIZE}`;
      pickerCssProps.holder.height = contained ? `${_constants.CONTAINED_LARGE_HEIGHT}rem` : `${_constants.TEXT_LARGE_HEIGHT}rem`;
      pickerCssProps.holder.minWidth = _constants.LARGE_MIN_WIDTH;
      pickerCssProps.button.fontSize = _constants.LARGE_FONT_SIZE;
      pickerCssProps.input.minWidth = _constants.LARGE_INPUT_WIDTH;
      pickerCssProps.input.width = _constants.LARGE_INPUT_WIDTH;
      pickerCssProps.input.height = _constants.LARGE_BUTTON_SIZE;
      pickerCssProps.button.width = _constants.LARGE_BUTTON_SIZE;
      pickerCssProps.button.height = _constants.LARGE_BUTTON_SIZE;
    }
    if (pickerHeight) {
      pickerCssProps.holder.height = pickerHeight;
    }
    if (expandOnFocus) {
      pickerCssProps.holder.background = 'transparent';
      pickerCssProps.holder.boxShadow = 'none';
      pickerCssProps.holder.padding = '0';
      pickerCssProps.holder.minWidth = 26;
      pickerCssProps.holder.width = '34px';
      pickerCssProps.holder.height = '26px';
      pickerCssProps.input.minWidth = '34px';
      pickerCssProps.input.width = '34px';
      pickerCssProps.input.height = '26px';
      pickerCssProps.button.fontSize = '20px';
      pickerCssProps.button.width = '26px';
      pickerCssProps.button.height = '26px';
    }
    return pickerCssProps;
  }, [elevation, expandOnFocus, pickerHeight, size, theme.palette.common.white, theme.shadows, variant, width]);
  const buttonProps = (0, _react.useMemo)(() => {
    const baseProps = {
      ...IconButtonProps
    };
    baseProps.type = 'button';
    baseProps.size = 'small';
    baseProps.variant = 'contained';
    baseProps.color = 'secondary';
    if (expandOnFocus) {
      return baseProps;
    }
    if (size === 'large') {
      baseProps.size = 'medium';
    }
    if (variant === 'text') {
      baseProps.size = 'medium';
    }
    if (variant === 'contained') {
      baseProps.variant = 'text';
      baseProps.color = 'default';
    }
    return baseProps;
  }, [IconButtonProps, expandOnFocus, size, variant]);
  return {
    cssProps,
    buttonProps
  };
}
